import { useEffect } from 'react';

const useOutside = (ref, onClose, passEvent = false) => {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                if (passEvent) {
                    onClose(event);
                } else {
                    onClose();
                }
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [ref, onClose, passEvent]);
};

export default useOutside;
